<template>
    <div class="license">
        <section class="section">
            <div class="section-row">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('licenses.label.license_plan_of_client') }}
                    </div>

                    <div class="value">
                        {{ trans('clients.label.' + client.license_plan) }} ({{ client.license.accounting_period == 1 ? trans('licenses.label.monthly').toLowerCase() : trans('licenses.label.quarterly').toLowerCase() }})
                    </div>
                </div>
            </div>

            <div class="section-row">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('licenses.label.used_licenses') }}
                    </div>

                    <div class="value">
                        {{ licenseUsage || trans('licenses.label.none') }}
                    </div>
                </div>

                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('licenses.label.overdue_assignments') }}
                    </div>

                    <div class="value">
                        {{ license.overdue_assignments || trans('licenses.label.none') }}
                    </div>
                </div>
            </div>

            <div class="section-row">
                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('licenses.label.last_accounting') }}
                    </div>

                    <div class="value">
                        {{ formatDate(license.last_accounting_at) }}
                    </div>
                </div>

                <div class="section-row__col section-row__col--one-half">
                    <div class="label">
                        {{ trans('licenses.label.next_accounting') }}
                    </div>

                    <div class="value">
                        {{ formatDate(license.next_accounting_at) }}
                    </div>
                </div>
            </div>

            <div class="section-row">
                <div class="section-row__col section-row__col--one-half" v-for="(value, key) in licenseConsumption" :key="key">
                    <div class="label">
                        {{ key }}
                    </div>

                    <div class="value">
                            {{ value || trans('licenses.label.none') }}
                    </div>
                </div>
            </div>
        </section>

        <div class="license__tiles">
            <div class="license__tile" v-if="canConfig">
                <license-tile
                    image="/images/reporting.svg"
                    :title="trans('bookings.tile.configuration.title')"
                    :body="trans('bookings.tile.configuration.body')"
                    :linkPrimary="route('tenant.clients.licenses.show', {'client': client.id, 'license': license.id})"
                    :titleLinkPrimary="trans('bookings.tile.configuration.link')"
                >
                </license-tile>
            </div>
        </div>
    </div>
</template>

<script>
var moment = require('moment');

export default {
    props: [
        'client',
        'license',
        'licenseConsumption',
        'licenseUsage',
        'canConfig',
    ],

    methods: {
        formatDate(date) {
            return moment(date).format('DD.MM.YYYY');
        },
    }
}
</script>
